export const JOB_PERKS_OPTIONS: string[] = [
    'Health Insurance',
    'Remote Work',
    'Flexible Hours',
    'Gym Membership',
    'Meal Allowance',
    'Relocation Bonus',
    'Stock Options',
    'Learning Budget',
    'Travel Allowance'
];